module.exports = "/static/Images/en/Two.png";